import { Error } from '../api/index';

const checkUnexpectedError = async ({ dispatch }, resData: Error) => {
    try {
        await dispatch('checkUnexpectedError', resData, { root: true });
    } catch (error) {
        return Promise.reject();
    }
};

const checkSystemError = async ({ dispatch }, resData: Error) => {
    try {
        await dispatch('checkSystemError', resData, { root: true });
    } catch (error) {
        return Promise.reject();
    }
};

export const checkFatalError = async ({ dispatch }, resData: Error) => {
    try {
        await checkUnexpectedError({ dispatch }, resData);
        await checkSystemError({ dispatch }, resData);
    } catch (error) {
        return Promise.reject();
    }
};
